import { useState, useEffect } from 'react';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import toast, { Toaster } from 'react-hot-toast';
import { fetchPlatformFee, addPlatformFee, updatePlatformFee, deletePlatformFee } from '../../apis/home/platformFee';

import { fetchDeliveryTypes, addDeliveryType, updateDeliveryType, deleteDeliveryType } from '../../apis/home/deliveryTypes';

export default function Platformfee() {

    const [platformFee, setPlatformFee] = useState([]);
    const [dialogVisible, setDialogVisible] = useState(false);
    const [newFee, setNewFee] = useState({ platformFee: '' });
    const [loading, setLoading] = useState(false);
    const [isEdit, setisEdit] = useState(false);
    const [editFee, seteditFee] = useState(null);

    const openDialog = () => setDialogVisible(true);
    const hideDialog = () => {
        setDialogVisible(false);
        setisEdit(false);
    };

    const typehandleKeyPress = (e) => {
        const regex = /^[a-zA-Z]$/;
        if (!regex.test(e.key)) {
            e.preventDefault();
        }
    };

    // const timehandleKeyPress = (e) => {
    //     const regex = /^[a-zA-Z0-9]$/;
    //     if (!regex.test(e.key)) {
    //         e.preventDefault();
    //     }
    // };

    const getDeliveryTypes = async () => {

        try {
            setLoading(true);
            const types = await fetchPlatformFee();
            setPlatformFee(types);
        } catch (error) {
            toast.error('Error: Fetching Platform Fee');
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        getDeliveryTypes();
    }, []);

    // function validatePromoCode(code) {
    //     const regex = /^[A-Za-z0-9]+$/;
    //     return regex.test(code);
    // }

    const saveDeliveryType = async () => {
        try {
            setLoading(true);
            if (isEdit) {
                if (!editFee.platformFee) {
                    toast.error('Please provide Platform Fee!');
                    return;
                }

                // if (!validatePromoCode(editFee.type)) {
                //     toast.error("Promo type must be alphanumeric only.");
                //     return;
                // }

                // await updateDeliveryType(editFee);
                const updatedDelivery = await updatePlatformFee(editFee);

                console.log(updatedDelivery);

                toast.success('Platform Fee Updated');

                const index = platformFee.findIndex(user => user.platformFeeId === editFee.platformFeeId);

                console.log(index);

                if (index !== -1) {

                    const updatedList = [...platformFee];
                    updatedList[index] = {
                        ...updatedList[index],
                        platformFee: editFee.platformFee
                    };
                    setPlatformFee(updatedList);

                    // console.log('Inside if');

                    // console.log(platformFee[index].platformFee);
                    // console.log(editFee.platformFee);
                    // // platformFee[index].type = editFee.type;
                    // // platformFee[index].time = editFee.time;
                    // platformFee[index].platformFee = editFee.platformFee;
                }

            } else {

                if (!newFee.platformFee) {
                    // toast.error('Please provide all type, time & price!');
                    toast.error('Please provide Platform Fee!');
                    return;
                }

                const addedFee = await addPlatformFee(newFee);
                newFee.platformFeeId = addedFee.id;

                // platformFee.push(newFee);

                setPlatformFee([...platformFee, newFee]);

                toast.success('Platform Fee Added');
            }

            setNewFee({ platformFee: '' });
            hideDialog();
        } catch (error) {
            console.log(error);

            toast.error(!isEdit ? 'Error: Adding Platform Fee' : 'Error: Editing Platform Fee');
        } finally {
            setLoading(false);
        }
    };

    const handleEdit = (item) => {
        console.log(item);

        setisEdit(true);
        setDialogVisible(true);
        seteditFee(item);
    };

    const handleDelete = async (item) => {
        try {

            if (platformFee.length == 1) {
                toast.error("Can't delete the only Platform Fee");
                return;
            }

            await deletePlatformFee(item.platformFeeId);
            toast.success('Platform Fee Deleted');
            setPlatformFee(prev => prev.filter(b => b.platformFeeId !== item.platformFeeId));
        } catch (error) {
            // alert(error);
            toast.error('Error: Deleting Platform Fee');
        } finally {
            setLoading(false);
        }
    };

    const actionTemplate = (rowData) => (
        <div className="p-d-flex p-ai-center gap-2">
            <Button
                icon="pi pi-pencil"
                className="p-button-text"
                tooltip="Edit Platform Fee"
                onClick={() => handleEdit(rowData)}
            />
            <Button
                icon="pi pi-trash"
                className="p-button-text p-button-danger"
                tooltip="Delete Platform Fee"
                onClick={() => handleDelete(rowData)}
            />
        </div>
    );

    return (
        <>
            <Toaster />
            <h2>Platform Fee</h2>

            {platformFee.length === 0 && (
                <Button label="Add Platform Fee" icon="pi pi-plus" onClick={openDialog} />
            )}

            <Dialog header={isEdit ? 'Edit Platform Fee' : 'Add Platform Fee'} visible={dialogVisible} onHide={hideDialog}>
                <div className="flex flex-col gap-3">

                    {
                        isEdit ?
                            <>
                                {/* <div className="p-field p-col-12" style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                                    <label htmlFor="promoCode">Platform Fee</label>
                                    <InputText placeholder="e.g - Express | Standard" value={editFee.type} onKeyPress={typehandleKeyPress} onChange={(e) => seteditFee({ ...editFee, type: e.target.value })} />
                                </div>
                                <div className="p-field p-col-12" style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                                    <label htmlFor="promoCode">Delivery Time</label>
                                    <InputText placeholder="e.g - 1 to 2 hrs" value={editFee.time} onChange={(e) => seteditFee({ ...editFee, time: e.target.value })} />
                                </div> */}
                                <div className="p-field p-col-12" style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                                    <label htmlFor="promoCode">Platform Fee - ₹</label>
                                    <InputText placeholder="e.g - 100" keyfilter="int" value={editFee.platformFee} onChange={(e) => seteditFee({ ...editFee, platformFee: e.target.value })} />
                                </div>
                            </>
                            :
                            <>
                                {/* <div className="p-field p-col-12" style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                                    <label htmlFor="promoCode">Platform Fee</label>
                                    <InputText placeholder="e.g - Express | Standard" maxLength={12} onKeyPress={typehandleKeyPress} onChange={(e) => setNewFee({ ...newFee, type: e.target.value })} />
                                </div>
                                <div className="p-field p-col-12" style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                                    <label htmlFor="promoCode">Delivery Time</label>
                                    <InputText placeholder="e.g - 1 to 2 hrs" onChange={(e) => setNewFee({ ...newFee, time: e.target.value })} />
                                </div> */}
                                <div className="p-field p-col-12" style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                                    <label htmlFor="promoCode">Platform Fee - ₹</label>
                                    <InputText placeholder="e.g - 100" keyfilter="int" onChange={(e) => setNewFee({ ...newFee, platformFee: e.target.value })} />
                                </div>
                            </>
                    }
                    <div style={{ paddingTop: '2rem' }}>
                        <Button loading={loading} label="Save" icon="pi pi-check" onClick={saveDeliveryType} />
                    </div>
                </div>
            </Dialog>

            <div className="p-m-3 mt-4">
                <DataTable value={platformFee} loading={loading} emptyMessage='No Platform Fee Found'>
                    <Column field="platformFee" header="Current Platform Fee" />
                    {/* <Column field="time" header="Delivery Time" /> */}
                    {/* <Column field="price" header="Delivery Price" /> */}
                    <Column header="Actions" body={actionTemplate} />
                </DataTable>
            </div>
        </>
    );
}